"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VcfStatusService = void 0;
const VcfMeasurementsError_1 = require("../errors/VcfMeasurementsError");
const types_1 = require("../../shared/types");
class VcfStatusService {
    constructor(vcfStatusClient) {
        this.vcfStatusClient = vcfStatusClient;
    }
    async getCruisingRange(vin, devicePlatform) {
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        let statusResponse;
        statusResponse = await this.vcfStatusClient.getFuelStatus(vin, isWcar);
        try {
            const data = statusResponse === null || statusResponse === void 0 ? void 0 : statusResponse.data[0];
            const lastUpdate = data.carCapturedTimestamp;
            const value = parseInt(data.properties.find((p) => p.name === 'remainingRange_km').value);
            return { lastUpdate, value };
        }
        catch (e) {
            throw new VcfMeasurementsError_1.VcfMeasurementsError('Could not parse VCF fuel status response');
        }
    }
    async getCruisingRangeElectricCar(vin, devicePlatform) {
        const isWcar = devicePlatform === types_1.DevicePlatform.WCAR;
        let statusResponse;
        statusResponse = await this.vcfStatusClient.getChargingStatus(vin, isWcar);
        try {
            const data = statusResponse === null || statusResponse === void 0 ? void 0 : statusResponse.data;
            const lastUpdate = data.batteryStatus.carCapturedTimestamp;
            const value = parseInt(data.batteryStatus.cruisingRangeElectric_km);
            return { lastUpdate, value };
        }
        catch (e) {
            throw new VcfMeasurementsError_1.VcfMeasurementsError('Could not parse VCF fuel status response');
        }
    }
}
exports.VcfStatusService = VcfStatusService;
//# sourceMappingURL=VcfStatusService.js.map